<template>
  <v-dialog v-model='dialog' scrollable max-width='800px'>
    <template #activator='activator'>
      <slot name='activator' v-bind='activator'></slot>
    </template>
    <v-card>
      <v-tabs
        v-model='tab'
        background-color='indigo'
        dark
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab href='#tab-1'>
          固定ページ
        </v-tab>

        <v-tab href='#tab-2'>
          HTMLページ
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model='tab'>
        <v-tab-item
          :value="'tab-1'"
        >
          <v-card-text>
            <permission-guard situation='media_page_management'>
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class='text-left'>タイトル</th>
                    <th class='text-left'>slug</th>
                    <th class='text-left'>URL</th>
                    <th class='text-center'>最終更新日</th>
                    <th class='text-center'></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for='page in mediaPages' :key='page.id'>
                    <td class='text-left'>
                      {{ page.title }}
                    </td>
                    <td class='text-left'>
                      {{ page.slug }}
                    </td>
                    <td class='text-left'>
                      {{ page.url }}
                    </td>
                    <td class='text-center'>
                      {{ page.updatedAt | moment }}
                    </td>
                    <td class='text-center'>
                      <v-btn color="primary" @click='selectPage(page)'>
                        設定
                      </v-btn>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </permission-guard>
          </v-card-text>
        </v-tab-item>
        <v-tab-item
          :value="'tab-2'"
        >
          <v-card-text>
            <permission-guard situation='html_page_management'>
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class='text-center'>id</th>
                    <th class='text-center'>ページ名</th>
                    <th class='text-center'>公開URL</th>
                    <th class='text-center'>適用中のバージョン</th>
                    <th class='text-center'></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for='htmlPage in htmlPages' :key='htmlPage.id'>
                    <td class='text-center'>
                      {{ htmlPage.id }}
                    </td>
                    <td class='text-center'>
                      {{ htmlPage.title }}
                    </td>
                    <td class='text-center'>
                      <a :href='htmlPagePublicUrl(htmlPage)' target='_blank'>
                        {{ htmlPagePublicUrl(htmlPage) }}
                      </a>
                    </td>
                    <td class='text-center'>{{ htmlPage.applyVersion }}</td>
                    <td class='text-center'>
                      <v-btn color="primary" @click='selectPage(htmlPage)'>
                        設定
                      </v-btn>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <infinite-loading
                spinner='spiral'
                class='mt-4'
                :identifier='infiniteHtmlPageId'
                @infinite='infiniteHTMLPagesHandler'
              >
                <template v-slot:no-more>
                  <v-chip label outlined> 全て表示されました。</v-chip>
                </template>
                <template v-slot:no-results>
                  <v-chip label outlined> 表示できるものがありません。</v-chip>
                </template>
              </infinite-loading>
            </permission-guard>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <v-card-actions>
        <v-btn color='danger' text @click='dialog = false'>
          キャンセル
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PermissionGuard from '@/components/commons/PermissionGuard'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import InfiniteLoading from 'vue-infinite-loading'
import { mapState } from 'vuex'
import urlUtils from '@/mixins/url_utils'
import moment from 'moment'
import Qs from 'qs'

export default {
  name: 'SelectPageDialog',
  components: {
    PermissionGuard,
    InfiniteLoading
  },
  mixins: [urlUtils],
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY年M月D日 HH時mm分')
    }
  },
  data () {
    return {
      dialog: false,
      tab: null,
      mediaPages: [],
      htmlPages: [],
      htmlPagesPaginationPage: 0,
      infiniteHtmlPageId: +new Date()
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    })
  },
  mounted () {
    this.fetchMediaPages()
  },
  methods: {
    fetchMediaPages () {
      axios
        .get('/api/media_pages', {
          params: {
            q: {
              is_published_eq: true
            }
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(
          ({ data }) => {
            this.mediaPages = deserialize(data).data
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: `固定ページの取得に失敗しました（${error.response.data.errors.toString()}）`
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
    infiniteHTMLPagesHandler ($state) {
      axios
        .get('/api/html_pages', {
          params: {
            q: {
              published_eq: true
            },
            page: this.htmlPagesPaginationPage
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(
          ({ data }) => {
            const fetchedHtmlPages = deserialize(data).data

            if (fetchedHtmlPages.length > 0) {
              this.htmlPagesPaginationPage++
              this.htmlPages = this.htmlPages.concat(fetchedHtmlPages)
              $state.loaded()
            } else {
              $state.complete()
            }
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    selectPage (page) {
      this.$emit('select', page)
      this.dialog = false
    }
  }
}
</script>
